import { render, staticRenderFns } from "./UserDetailHeader.vue?vue&type=template&id=47b8831f"
import script from "./UserDetailHeader.vue?vue&type=script&lang=js"
export * from "./UserDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports